import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class O365Service {

  constructor(private http: HttpClient) { }

  grantAccess(code: string, emailAddress: string): Observable<any> {
    var model = {
      code: code,
      email_address: emailAddress
    };

    return this.http
      .post(
        `/api/v1/o365/grant`,
        model
      );
  }

  grantAccessBot(code: string, emailAddress: string): Observable<any> {
    var model = {
      code: code,
      email_address: emailAddress
    };

    return this.http
      .post(
        `/api/v1/o365/bot/grant`,
        model
      );
  }

  testAccess(inboxId: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/o365/test/${inboxId}`
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/o365.service.ts